import React, { useState } from "react";
import CopyIcon from "@icons/copy-03.svg?react";
import CheckIcon from "@icons/check.svg?react";
import { Tooltip } from "react-tooltip";
import { toolTipStyles } from "@/theme";
import { toast } from "react-toastify";

interface CopyButtonProps {
    onCopy: () => void;
    id: string;
    ariaLabel?: string;
    tooltipText?: string;
    toastMessage?: string;
    className?: string;
    iconClassName?: string;
    copyValue?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
    onCopy,
    id,
    ariaLabel,
    tooltipText,
    toastMessage,
    className = "focused self-end rounded-md border border-gray-300 bg-gray-100 px-4 py-2 font-semibold text-gray-500 hover:text-gray-600 hover:shadow-sm hover:ring-1 hover:ring-inset hover:ring-gray-100 hover:bg-gray-200",
    iconClassName = "w-4 h-4",
    copyValue,
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (copyValue) {
            await navigator.clipboard.writeText(copyValue);
        }
        onCopy();
        setCopied(true);
        if (toastMessage) {
            toast.success(toastMessage);
        }
        setTimeout(() => setCopied(false), 2000); // Revert back to copy icon after 2 seconds
    };

    return (
        <>
            {tooltipText && (
                <Tooltip content={tooltipText} anchorSelect={`#${id}`} positionStrategy="fixed" style={toolTipStyles} />
            )}
            <button
                id={id}
                data-happydoc-id={id}
                type="button"
                aria-label={ariaLabel}
                onClick={handleCopy}
                className={className}
            >
                {copied ? <CheckIcon className={iconClassName} /> : <CopyIcon className={iconClassName} />}
            </button>
        </>
    );
};

export default CopyButton;
